import moment from 'moment';
import {
    TimeLengthTypesEnum, DemoStatusEnum, OrderStatusEnum, OrderRefundStatusEnum, PaymentMethodEnum, SaleStatusEnum, SaleTypesEnum,
    CustomerStatusEnum, CustomerTitleEnum, ZoneChangeReasonEnum, StockItemTypesEnum, ReferralStatus
} from "../common/enums";

//import configureStore from "../store/configureStore";
//import store from '../store/configureStore';

//const store = configureStore();
//const state = store.getState();
//const settings = state.settings;
//-------------------------------------------------------

//-------------------------------------------------------
export const utils = {
    settings: null,
    /**
        * Get Object property case insensitive
        * @param {Object} object
        * @param {string} key
        * @return {any} value
    */
    getPropCaseInsensitive: function(object, key) {
    const asLowercase = key.toLowerCase();
    return object[Object.keys(object)
      .find(k => k.toLowerCase() === asLowercase)
    ];
  },
      /**
        * Set Object property case insensitive
        * @param {Object} object
        * @param {string} key to search for
        * @param {any} value value to set
    */
      setPropCaseInsensitive: function(object, key, value) {
        const asLowercase = key.toLowerCase();
        var prop = Object.keys(object).find(k => k.toLowerCase() === asLowercase);
        if(prop)
            object[prop] = value;
      },
    getYoutubeId: function (videoUrl) {
        var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        var match = videoUrl.match(regExp);

        if (match && match[2].length === 11) {
            return match[2];
        } else {
            return 0;
        }
    }
    , getWebshopFullUrl(settings) {
        if (!window.location.origin) {
            window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
        }
        const url = `${window.location.origin}/shop${settings.baseUrl}`

      //  console.log(url);
        return url;

    }
    , getLinkUrl(link, settings) {
        const baseUrlWithoutLeadingSlash = settings.baseUrl.substring(1);
        if (link.useRepresentativeEmail === true) {
            return `mailto:${settings.defaultRepresentative.email}`;
        }
      //  console.log(`${settings.baseUrl}${link.contentUrl}`);
        return link.isRelativeUrl === true ? `${baseUrlWithoutLeadingSlash}${link.contentUrl}` : link.contentUrl;

    }
    , addhttps(url) {
        if (!/^(?:f|ht)tps?\:\/\//.test(url)) {
            url = "https://" + url;
        }
        return url;
    }
    , htmlDecode: function (content) {
        if (utils.isNullOrEmpty(content))
            return content;

        let txt = document.createElement("textarea");
        txt.innerHTML = content;
        return txt.value;

        //let e = document.createElement('div');
        //e.innerHTML = content;
        //return e.childNodes.length === 0 ? "" : e.childNodes[0].nodeValue;
    }
    , scrollTop: function (elemSelector) {
        const $ = window.$, $elem = $(elemSelector);
        let scrollPosition = 0;
        if ($elem && $elem.length > 0) {
            scrollPosition = $elem.offset().top;
        }
        $("html, body").animate({ scrollTop: scrollPosition }, 300);
    },
    loadScript: (url, callback) => {

        let script = document.createElement("script");
        script.type = "text/javascript";

        if (script.readyState) {
            script.onreadystatechange = function () {
                if (script.readyState === "loaded" || script.readyState === "complete") {
                    script.onreadystatechange = null;
                    callback();
                }
            };
        } else {
            script.onload = () => callback();
        }

        script.src = url;
        document.getElementsByTagName("head")[0].appendChild(script);
    }
    , injectScript: (scriptContent) => {

        let script = document.createElement("script");
        script.type = "text/javascript";


        script.textContent = scriptContent;

        document.getElementsByTagName("head")[0].appendChild(script);
    }
    , convertArrayToObject: function(array, key){
        const initialValue = {};
        return array.reduce((obj, item) => {
            return {
                ...obj,
                [item[key]]: item,
            };
        }, initialValue);
    }
    , fallbackCopyTextToClipboard: function (text) {
        var textArea = document.createElement("textarea");
        textArea.value = text;

        // Avoid scrolling to bottom
        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.position = "fixed";

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            var successful = document.execCommand('copy');
            var msg = successful ? 'successful' : 'unsuccessful';
            console.log('Fallback: Copying text command was ' + msg);
        } catch (err) {
            console.error('Fallback: Oops, unable to copy', err);
        }

        document.body.removeChild(textArea);
    }
    , copyTextToClipboard: function (text) {
        if (!navigator.clipboard) {
            utils.fallbackCopyTextToClipboard(text);
            return;
        }
        navigator.clipboard.writeText(text).then(function () {
            console.log('Async: Copying to clipboard was successful!');
        }, function (err) {
            console.error('Async: Could not copy text: ', err);
        });
    }
    //-------------------------------------------------------
    , downloadFileAsBlob: function (url, loadingContainer) {
        utils.UI.showLoading(loadingContainer, true);
        var req = new XMLHttpRequest();
        req.open("POST", url, true);
        req.setRequestHeader('Content-type', 'application/json; charset=utf-8');
        req.responseType = "blob";
        req.onload = function (event) {
            var blob = req.response;
            var fileName = req.getResponseHeader("filename") //if you have the fileName header available
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            utils.UI.showLoading(loadingContainer, false);
        };
        req.send();

    }
    //-------------------------------------------------------
    , formatCurrencyAsNumber: function (valuestr, defaultValue) {
        var result = defaultValue ? defaultValue : "";
        if (valuestr || valuestr === 0) {
            result = valuestr;
        }
        result = (utils.parsers.parseFloat(valuestr)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        return result;
    }
    //-------------------------------------------------------
    , formatCurrency: function (valuestr, defaultValue) {
        var result = defaultValue ? defaultValue : "";
        if (valuestr || valuestr === 0) {
            result = valuestr;
        }
        if (utils.isNullOrEmpty(result)) {
            return "";
        }

        result = utils.settings.currencySymbol + "" + (utils.parsers.parseFloat(valuestr)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        return result;
    }
    //-------------------------------------------------------
    // fornate string as percentage 0.1 = 10 %
    , formatPercentage: function (valuestr, defaultValue, numOfDecimalDigits) {
        var result = defaultValue ? defaultValue : 0;
        if (valuestr || valuestr === 0) {
            result = valuestr;
        }

        numOfDecimalDigits = numOfDecimalDigits >= 0 ? numOfDecimalDigits : 2;
        result = utils.parsers.parseFloat(result);
        if (valuestr < 1) {
            result = result * 100;
        }

        result = result.toFixed(numOfDecimalDigits).replace(/\d(?=(\d{3})+\.)/g, '$&,') + " %";
        return result;
    }
    //-------------------------------------------------------
    , randomIntFromInterval: function (min, max) { // min and max included
        return Math.floor(Math.random() * (max - min + 1) + min);
    }
    //-------------------------------------------------------
    // get querystring Value
    , getQueryStringValue: function (name, url) {
        if (!url) {
            url = window.location.href.toString().toLowerCase();
        }
        name = name.replace(/[[\]]/g, "\\$&").toLowerCase();
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) {
            return null;
        } else if (utils.isNullOrEmpty(results[2])) {
            return null;
        }

        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
    //-----------------------------------------
    , isNullOrEmpty: function (value) {
        return typeof value === 'undefined' || value === null || value === "" ? true : false;
    }
    , formatString: function (value, ...args) {
       // var args = arguments;
        return value.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] != 'undefined'
                ? args[number]
                : match
                ;
        });
    }
    //-------------------------------------------------------
    , trimAll: function (value) {
        return value.replace(/\s/g, '');
    }

    //-------------------------------------------------------
    , replaceQueryStringValue: function (url, param, value) {

        var re = new RegExp("[\\?&]" + param + "=([^&#]*)"), match = re.exec(url), delimiter, newString;

        if (match === null) {
            // append new param
            var hasQuestionMark = /\?/.test(url);
            delimiter = hasQuestionMark ? "&" : "?";
            newString = url + delimiter + param + "=" + value;
        } else {
            delimiter = match[0].charAt(0);
            newString = url.replace(re, delimiter + param + "=" + value);
        }

        return newString;

    }
    //-------------------------------------------------------
    // storage common methods
    //-------------------------------------------------------
    , storage: {
        //-------------------------------------------------------
        // Add Session Data
        addSessionItem: function (itemKey, itemValue) {
            if (window.sessionStorage && itemKey !== null && itemValue !== null)
                window.sessionStorage.setItem(itemKey, JSON.stringify(itemValue));
        }
        //-------------------------------------------------------
        // get Session Data
        , getSessionItem: function (itemKey) {
            var result = null;
            if (window.sessionStorage)
                result = window.sessionStorage.getItem(itemKey);

            return result !== null ? JSON.parse(result) : result;
        }
        //-------------------------------------------------------
        // remove Session Data
        , removeSessionItem: function (itemKey) {
            if (window.sessionStorage)
                window.sessionStorage.removeItem(itemKey);
        }
        //-------------------------------------------------------
        // remove all Session Data
        , clearAllSessionItems: function () {

            if (window.sessionStorage)
                window.sessionStorage.clear();
        }
        //-------------------------------------------------------
        // Add Permenant Data
        , addPermenantItem: function (itemKey, itemValue) {
            if (window.localStorage && itemKey !== null && itemValue !== null)
                window.localStorage.setItem(itemKey, JSON.stringify(itemValue));
        }
        //-------------------------------------------------------
        // get Permenant Data
        , getPermenantItem: function (itemKey) {
            var result = null;
            if (window.localStorage)
                result = window.localStorage.getItem(itemKey);

            return result !== null ? JSON.parse(result) : result;
        }
        //-------------------------------------------------------
        // remove Session Data
        , removePermenantItem: function (itemKey) {
            var result = null;
            if (window.localStorage)
                result = window.localStorage.removeItem(itemKey);
            return result;
        }
        //-------------------------------------------------------
        // remove Session Data
        , clearAllPermenantItems: function () {
            if (window.localStorage)
                window.localStorage.clear();
        }
        //-------------------------------------------------------
    }
    //-------------------------------------------------------
    // Parsing Helper functions
    , parsers: {
        //-----------------------------------------
        // Parse value to Integer with rounding
        parseInt: function (valuestr, defaultValue) {
            var result = parseInt(valuestr, 10);
            if (result === null)
                result = defaultValue ? defaultValue : 0;
            return result;
        },
        //parseIntWithoutDecimalPoint: function (valuestr, defaultValue) {
        //    var result = parseFloat(valuestr, 2);
        //    if (result === null)
        //        result = defaultValue ? defaultValue : 0;
        //    return this.parseInt(Math.round(result) * 100);
        //    //return (int)(decimal.Round(value, 2, MidpointRounding.AwayFromZero) * 100);
        //    //return result * 100;
        //},
        //-----------------------------------------
        // Parse value to float
        parseFloat: function (valuestr, numOfDecimalDigits) {
            var result = parseFloat(valuestr);
            if (result === null)
                result = 0;

            if (numOfDecimalDigits && isNaN(numOfDecimalDigits) === false) {
                result = result.toFixed(2);
            }

            return result;
        },
        //-----------------------------------------
        // Parse value to string
        parseString: function (valuestr, defaultValue) {
            var result = defaultValue ? defaultValue : "";
            if (valuestr) {
                result = valuestr.toString();
            }
            return result;
        }
        //-----------------------------------------
        // Parse value to bool
        , parseBool: function (valuestr, defaultValue) {

            var result = utils.isNullOrEmpty(defaultValue) === false ? defaultValue : false;
            if (utils.isNullOrEmpty(valuestr) === false) {
                defaultValue = valuestr.toString().toLowerCase();
                result = defaultValue === "true" || defaultValue === "1" ? true : false;
            }
            return result;
        }
        //-----------------------------------------
        , isNullOrEmpty: function (value) {
            return utils.isNullOrEmpty(value);
        }
        //-----------------------------------------
    }
    //-------------------------------------------------------
    // Dates Helper functions
    , dates: {
        //-----------------------------------------
        getCurrentMonthFilter: function (month, year) {
            let todayDate = (month === undefined || year === undefined) ? new Date() : new Date(year, month - 1, 1),
                filterDateFrom = new Date(todayDate.getFullYear(), todayDate.getMonth(), 1),
                filterDateTo = new Date(todayDate.getFullYear(), todayDate.getMonth() + 1, 0);

            return { from: utils.dates.getServerDateString(filterDateFrom), to: utils.dates.getServerDateString(filterDateTo) };
        },
        //-----------------------------------------
        parseDateString: function (valuestr, format) {
            if (valuestr && valuestr !== "") {

                if (!format)
                    format = utils.settings.shortDatePattern;

                var date = format ? moment(valuestr, format.toUpperCase()) : moment(valuestr, utils.settings.shortDatePattern.toUpperCase());
                if (!date) {
                    date = moment(valuestr);
                }
                return date ? new Date(date.toDate()) : valuestr;
            }
            return valuestr;
        }
        //-----------------------------------------
        , parseJsonDateString: function (valuestr, format) {
            if (valuestr && valuestr !== "") {
                var date = format ? moment(valuestr, format.toUpperCase()) : moment(valuestr);
                if (!date) {
                    date = moment(valuestr, utils.settings.shortDatePattern.toUpperCase());
                }
                return date ? date : valuestr;
            }
            return valuestr;
        }
        //-----------------------------------------
        , getDateString: function (valuestr, format) {

            if (!valuestr)
                return "";
            // return date string on the given format
            if (!format)
                format = utils.settings.shortDatePattern.toUpperCase();

            valuestr = utils.dates.removeTimeZoneDiff(valuestr);

            valuestr = moment(valuestr).format(format);
            if (valuestr === "Invalid date")
                valuestr = "";
            return valuestr;
        }
        //-----------------------------------------
        , getDateTimeString: function (valuestr, format) {
            if (!valuestr)
                return "";
            // return date string on the given format
            if (!format)
                format = utils.settings.shortDatePattern.toUpperCase() + " - (LT)";

            valuestr = utils.dates.removeTimeZoneDiff(valuestr);

            valuestr = moment(valuestr).format(format);
            if (valuestr === "Invalid date")
                valuestr = "";
            return valuestr;
        }
        //-----------------------------------------
        , getDateTime24String: function (valuestr, format) {
            if (!valuestr)
                return "";
            // return date string on the given format
            if (!format)
                format = utils.settings.shortDatePattern.toUpperCase() + " - (HH:mm)";

            valuestr = utils.dates.removeTimeZoneDiff(valuestr);

            valuestr = moment(valuestr).format(format);
            if (valuestr === "Invalid date")
                valuestr = "";
            return valuestr;
        }
        //-----------------------------------------
        , getServerDateString: function (valuestr, format) {
            if (!valuestr)
                return "";
            // return date string on the given format
            if (!format)
                format = utils.settings.shortDatePattern.toUpperCase();

            valuestr = moment(valuestr).format(format);
            if (valuestr === "Invalid date")
                valuestr = "";
            return valuestr;
        }
        //-----------------------------------------
        , getTimeString: function (valuestr, format) {
            if (!valuestr)
                return "";
            // return date string on the given format
            if (!format)
                format = "hh:mm a";

            valuestr = moment(valuestr).format(format);
            if (valuestr === "Invalid date")
                valuestr = "";
            return valuestr;
        }
        //-----------------------------------------
        , compare: function (date1, date2) {
            // return 0 if equal , 1 is greater than , -1 if less than
            if (!(date1 && date2))
                return -1;

            var dateDif = moment(date1).startOf('day').diff(moment(date2).startOf('day'), 'days');
            return dateDif === 0 ? 0 : (dateDif > 0 ? 1 : -1);
        }
        //-----------------------------------------
        , isBetween: function (d, start, end) {
            // check date is between two dates
            return moment(d).isBetween(moment(start), moment(end), 'day');
        }
        //-----------------------------------------
        , isSame: function (date1, date2) {
            // check date is  after another date
            return moment(date1).isSame(moment(date2), 'day');
        }
        //-----------------------------------------
        , isAfter: function (date1, date2) {
            // check date is  after another date
            return moment(date1).isAfter(moment(date2).endOf('day'), 'day');
        }
        //-----------------------------------------
        , isBefore: function (date1, date2) {
            // check date is before another date
            return moment(date1).isBefore(moment(date2).startOf('day'), 'day');
        }
        , isSameOrAfter: function (date1, date2) {
            // check date is same or after another date
            return moment(date1).isSameOrAfter(moment(date2).endOf('day'), 'day');
        }
        //-----------------------------------------
        , isSameOrBefore: function (date1, date2) {
            // check date is same or before another date
            return moment(date1).isSameOrBefore(moment(date2).startOf('day'), 'day');
        }
        //-----------------------------------------
        , addTimeToDate: function (dateObject, addLength, lengthType) {
            var addType = "days";
            switch (lengthType) {
                case TimeLengthTypesEnum.Week: {
                    addType = "weeks";
                    break;
                }
                case TimeLengthTypesEnum.Month: {
                    addType = "months";
                    break;
                }
                case TimeLengthTypesEnum.Year: {
                    addType = "years";
                    break;
                }
                default:
                    break;
            }
            var date = moment(dateObject);
            date = date.add(addLength, addType);
            return date;
        }
        //-----------------------------------------
        , removeTimeZoneDiff: function (dateString) {
            var result = dateString;
            if (typeof (result) === "string") {
                if (result.indexOf("T") > -1) {
                    var dateArr = result.split("T");
                    var timePart = "";
                    var datePart = dateArr[0];
                    if (dateArr.length > 1) {
                        timePart = dateArr[1];
                        timePart = timePart.split("+")[0].split("-")[0];
                    }
                    result = datePart + "T" + timePart;
                }
            }
            return result;
        }
        //-----------------------------------------
    }
    //-------------------------------------------------------
    // UI helper methods
    //-------------------------------------------------------
    , UI: {
        //-------------------------------------------------------
        showLoading: function ($viewElement, isloading) {
            // const $ = window.$;
            // kendo.ui.progress($viewElement, isloading);
            if ($viewElement) {
                var template = `<div class="bounce-loader-container">
                                <div class="bouncy-balls-container ">
                                    <div class="ball ball-one"></div>
                                    <div class="ball ball-two"></div>
                                    <div class="ball ball-three"></div>
                                    <div class="ball ball-four"></div>
                                    <div class="shadow shadow-one"></div>
                                    <div class="shadow shadow-two"></div>
                                    <div class="shadow shadow-three"></div>
                                    <div class="shadow shadow-four"></div>
                             </div>
                    </div>`;
                if (isloading)
                    $viewElement.append(template);
                else
                    $viewElement.children('.bounce-loader-container').remove();
            }
        }
    }



    , validations: {
        /**
     * Calculate a Luhn (Mod10) checksum
     *   -or-
     * Verify the Luhn checksum of a credit card or IMEI number
     *
     * This implementation was adapted from the following sources:
     *   - https://en.wikipedia.org/w/index.php?title=Luhn_algorithm&oldid=688221366
     *   - https://gist.github.com/ShirtlessKirk/2134376
     */

        luhn: {
            /* Calculates the Luhn checksum */
            calculate: function (digits) {
                var sum = this.sum(digits, false);
                return (sum * 9) % 10;
            },

            /* Verifies if a number is a valid Luhn checksum */
            verify: function (digits) {
                var sum = this.sum(digits, true);
                return sum > 0 && sum % 10 === 0;
            },

            /* Sum each digit from right to left, and double
               every second digit. If the double exceeds 9,
               then sum its digits (i.e., 654321 -> 358341
               -> 24) */
            sum: function (digits, even) {
                var sum = 0,
                    digit = 0,
                    i = digits.length;

                while (i--) {
                    digit = Number(digits[i]);
                    sum += (even === !even) ? this.computed[digit] : digit;
                }

                return sum;
            },

            /* Create a precomputed list based on doubling
               each digit, as described in sum(). */
            computed: [0, 2, 4, 6, 8, 1, 3, 5, 7, 9]
        },

        /* Appends a Luhn checksum to the end of a number */
        createLuhnId: function (number) {
            var digits = String(number);
            return digits + utils.validations.luhn.calculate(digits);
        },

        /* Checks if a credit card or IMEI number is valid */
        isValidLuhn: function (number) {
            return utils.validations.luhn.verify(String(number));
        },

        //-----------------------------------------
        isNullOrEmpty: function (value) {
            return utils.isNullOrEmpty(value);
        }
         //-----------------------------------------
        , isStrongPassword: function (password) {
            return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#\$%\^&\*\(\)_\-\+=\[\{\]\};:<>\|\.\/\?])[A-Za-z\d!@#\$%\^&\*\(\)_\-\+=\[\{\]\};:<>\|\.\/\?]{8,}$/.test(password);
        }
    }
    //-------------------------------------------------------
    //-------------------------------------------------------
    // Business common methods
    //-------------------------------------------------------
    //-------------------------------------------------------
    // demos common methods
    //-------------------------------------------------------
    , demos: {
        getDemoStatusString: function (status) {
            return utils.getEnumValueAsString(status, DemoStatusEnum, utils.translate("Open"));
        }
    }
    //-------------------------------------------------------
    // orders common methods
    //-------------------------------------------------------
    , orders: {
        //------------------------------------
        getOrderStatusString: function (status) {
            var result = utils.translate("New");
            switch (status) {
                case OrderStatusEnum.Provisional:
                    {
                        result = utils.translate("Provisional");
                        break;
                    }
                case OrderStatusEnum.Cancelled:
                    {
                        result = utils.translate("Cancelled");
                        break;
                    }
                case OrderStatusEnum.Ordered:
                    {
                        result = utils.translate("Ordered");
                        break;
                    }
                case OrderStatusEnum.Warehouse:
                    {
                        result = utils.translate("Warehouse");
                        break;
                    }
                case OrderStatusEnum.Dispatched:
                    {
                        result = utils.translate("Dispatched");
                        break;
                    }
                case OrderStatusEnum.CorrectionCredit:
                    {
                        result = utils.translate("Credit");
                        break;
                    }
                case OrderStatusEnum.CorrectionCharge:
                    {
                        result = utils.translate("Charge");
                        break;
                    }
                default:
                    break;
            }
            return result;
        }
        //------------------------------------
        , getOrderRefundStatusString: function (status) {
            return utils.getEnumValueAsString(status, OrderRefundStatusEnum, utils.translate("None"));
        }
        //------------------------------------
        , getPaymentMethodString: function (paymentMethod) {
            return utils.getEnumValueAsString(paymentMethod, PaymentMethodEnum, utils.translate("None"));
        }
        //------------------------------------
        , getOrderRefundStatusCss: function (status) {
            var result = "";
            switch (status) {
                case OrderRefundStatusEnum.None:
                    {
                        //result = utils.translate("None");
                        break;
                    }
                case OrderRefundStatusEnum.Refunded:
                    {
                        result = " Refunded ";
                        break;
                    }
                case OrderRefundStatusEnum.RefundCounter:
                    {
                        result = " RefundCounter ";
                        break;
                    }
                case OrderRefundStatusEnum.PartiallyRefunded:
                    {
                        result = " PartiallyRefunded ";
                        break;
                    }
                case OrderRefundStatusEnum.PartialRefundCorrection:
                    {
                        result = " PartialRefundCorrection ";
                        break;
                    }
                default:
                    break;
            }
            return result;
        }
        //------------------------------------
        , formatOrderInvoiceNumber: function (num) {
            if (num) {
                var places = 6;
                var zero = places - num.toString().length + 1;
                return Array(+(zero > 0 && zero)).join("0") + num;
            }

            return "000000";
        }
        //------------------------------------
    }
    //-------------------------------------------------------
    // sales common methods
    //-------------------------------------------------------
    , sales: {
        //----------------------------------------
        getSaleStatusString: function (status) {
            return utils.getEnumValueAsString(status, SaleStatusEnum, utils.translate("New"));
        }
        //----------------------------------------
        , getSaleTypeString: function (status) {
            return utils.getEnumValueAsString(status, SaleTypesEnum, utils.translate("OneToOne"));
        }


        //----------------------------------------
    }
    //-------------------------------------------------------
    // customers common methods
    //-------------------------------------------------------
    , customers: {
        //----------------------------------------
        getCustomerStatusString: function (status) {
            return utils.getEnumValueAsString(status, CustomerStatusEnum, utils.translate("Active"));
        }
        //----------------------------------------
        , getCustomerTitleString: function (titleId) {
            return utils.getEnumValueAsString(titleId, CustomerTitleEnum, "");
        }
        //----------------------------------------
        , getZoneChangeReasonString: function (status) {
            return utils.getEnumValueAsString(status, ZoneChangeReasonEnum, utils.translate("Incomplete"));
        }
        //----------------------------------------
    }
    //-------------------------------------------------------
    // promotions common methods
    //-------------------------------------------------------
    , promotions: {
        //----------------------------------------
        getStockItemTypeString: function (status) {
            return utils.getEnumValueAsString(status, StockItemTypesEnum, utils.translate("Default"));
        }
        //----------------------------------------
    }
    , referral: {
        getStatusColor(referral) {
            if (referral.referralStatus === ReferralStatus.AlreadyHasAccount)
                return "text-danger";
            else if (referral.referralStatus === ReferralStatus.Pending)
                return "text-warning";
            else if (referral.referralStatus === ReferralStatus.Verified)
                return "text-success";
            return "text-info";
        },
        getStatus(referralStatus) {
            return utils.getEnumValueAsString(referralStatus, ReferralStatus);
        }
    }
    //-------------------------------------------------------
    , getEnumValueAsString: function (value, enumObject, defaultValue) {
        const $ = window.$;
        var result = defaultValue ? defaultValue : "";
        var keys = Object.keys(enumObject);
        $.each(keys, function (index, key) {
            //utils.logConsole(enumObject[key])
            //utils.logConsole(value)
            if (enumObject[key] === value) {
                result = utils.translate(key);
                return false;
            }
        });

        return result;
    }
    //-------------------------------------------------------
    , getEnumAsDataSource: function (enumObject) {
        const $ = window.$;
        var result = [];
        var keys = Object.keys(enumObject);
        $.each(keys, function (index, key) {
            result.push({ Id: enumObject[key], Name: utils.translate(key) });
        });

        return result;
    }
    //-------------------------------------------------------
    , translate: function (key) {

        return key;
    }

};

